import React, { useState } from 'react';
import MeasureOrderCreation from '../measureOrderCreation/MeasureOrderCreation';
import MeasureOrderTable from '../measureOrderTable/MeasureOrderTable';
import { TaskData } from '../../../../types/TaskData';
import './MeasureOrder.css';
import {ViewType} from "../../../../types/ViewType";

const MeasureOrder: React.FC = () => {
    const [selectedRows, setSelectedRows] = useState<TaskData[]>([]);
    const [refreshKey, setRefreshKey] = useState(0);

    const handleRowSelect = (rows: TaskData[]) => {
        setSelectedRows(rows);
    };

    const onRefreshTable = () => {
        setSelectedRows([]);
        setRefreshKey(prevKey => prevKey + 1);
    };

    return (
        <div className="measure-order-container">
            <div className="table-container-measure">
                <MeasureOrderTable onSelectRows={handleRowSelect} refreshKey={refreshKey} />
            </div>
            <div className="detail-container-measure">
                {selectedRows.length > 0 && (
                    <MeasureOrderCreation key={selectedRows.map(row => row.id).join('-')} data={selectedRows} onRefreshTable={onRefreshTable} viewType={ViewType.NEW}  />
                )}
            </div>
        </div>
    );
};

export default MeasureOrder;
